module.exports = __webpack_public_path__ + "static/media/TS_Icon.26cc95f2.png";